// src/components/onboarding/SellerSteps.tsx
"use client";

import {
  Box,
  Button,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import React, { useState } from "react";

export interface TStepData {
  id: number | string;
  icon: React.ElementType;
  title: string;
  shortTitle: string;
  description: string;
  image: string;
}

interface SellerStepsProps {
  steps: TStepData[]; // Data langkah-langkah wajib diterima dari luar
}

export const SellerSteps: React.FC<SellerStepsProps> = ({ steps }) => {
  // Handle jika tidak ada data steps yang diberikan
  const [activeStepId, setActiveStepId] = useState(steps[0].id);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!steps || steps.length === 0) {
    return null; // Atau tampilkan pesan placeholder
  }

  const currentStep =
    steps.find((step) => step.id === activeStepId) || steps[0];

  return (
    <section>
      <Paper
        elevation={3}
        className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 rounded-3xl h-full p-4 md:p-8"
      >
        {/* Kolom Kiri: Navigasi Langkah (menggunakan data dari props) */}
        <div className="flex flex-row md:flex-col gap-2 p-0 overflow-x-auto whitespace-nowrap border-b border-gray-200 sm:border-none">
          {steps.map((step) => {
            const isActive = step.id === activeStepId;
            return (
              <Box className="w-full justify-left" key={step.id}>
                <Button
                  onClick={() => setActiveStepId(step.id)}
                  variant={isActive ? "contained" : "text"}
                  startIcon={<step.icon />}
                  className={`
                    transition-all w-full min-w-full justify-start text-left p-4 font-semibold text-base text-gray-600 hover:bg-white hover:shadow-md rounded-lg ${isActive && "bg-white text-green-umkms shadow-md border-2 border-green-umkms"}
                  `}
                >
                  {step.shortTitle}
                </Button>
              </Box>
            );
          })}
        </div>

        {/* Kolom Kanan: Konten Langkah (menggunakan data dari props) */}
        <div className="md:col-span-2 flex flex-col items-center md:items-start rounded p-3 gap-8 transition-all">
          <div className="flex-1 text-left">
            <Typography
              variant="h4"
              className="font-bold text-green-800 text-center md:text-start"
            >
              {currentStep.title}
            </Typography>
            <Typography
              variant="body1"
              className="mt-4 text-gray-600 text-center md:text-start"
            >
              {currentStep.description}
            </Typography>
          </div>
          <div className="flex-1 mt-6 md:mt-0 flex justify-center sm:justify-left">
            <Image
              src={currentStep.image}
              alt={currentStep.title}
              width={isMobile ? 250 : 300}
              height={isMobile ? 250 : 300}
              style={{ objectFit: "contain" }}
            />
          </div>
        </div>
      </Paper>
    </section>
  );
};
